import React, { useState, useEffect } from "react";
import { Box, Button } from "@mui/material";
import TextField from "@mui/material/TextField";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import LoopIcon from '@mui/icons-material/Loop';
import { useApolloClient } from "@apollo/client";
import { GET_POLICYRECORD_BY_PERSONAL_ID } from "./QueryPersonal";

const ViewPoliceRecord = ({ id, params }) => {
  const { setAlertCustom, alertCustom, handleCloseModal } = params;
  const client = useApolloClient();
  const [visibility, setvisibility] = useState(false);
  const [policyRecordFicha, setpolicyRecordFicha] = useState(null);
  useEffect(() => {
    const getpolicyRecordFicha = async (id) => {
      try {
        const { data } = await client.query({
          query: GET_POLICYRECORD_BY_PERSONAL_ID,
          variables: {
            getPolicyRecordByPersonalIdId: id,
          },
          fetchPolicy: "network-only",
        });        
        setpolicyRecordFicha(data.getPolicyRecordByPersonalId);
        setvisibility(true);
      } catch (error) {
        setAlertCustom({
          ...alertCustom,
          type: "error",
          message: error.message,
          state: true,
        });
      }
    };
    getpolicyRecordFicha(id);
  }, []);
  const style = {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
  };
  return (
    visibility ? (
      <>
        {" "}
        <Box mt="20px">
          <Box sx={style}>
            <label for="my-input">¿ANTECEDENTES PENALES?</label>
            <TextField disabled value={policyRecordFicha?.have?"SI":"NO"} />
          </Box>
        </Box>
        <Box my={"20px"}>
          <TableContainer style={{ maxHeight: 550, overflowY: "auto" }}>
            <Table stickyHeader aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="">N°</TableCell>
                  <TableCell align="">CRITERIO</TableCell>
                  <TableCell align="">RESPUESTA</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {policyRecordFicha.policerecordsentence.map((row, index) => {
                  return (
                    <TableRow
                      key={row.id}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell align="">{index + 1}</TableCell>
                      <TableCell align="">{row.sentence.description}</TableCell>
                      <TableCell align="">{row.answer}</TableCell>
                    </TableRow>
                    /* </RadioGroup> */
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
        <Box display={"flex"} justifyContent={"end"} marginTop={"30px"}>
          <Button variant="contained" onClick={handleCloseModal}>
            CERRAR
          </Button>
          {/*  */}
        </Box>
      </>
    ):<Box sx={{display:"flex",justifyContent:"center"}}><LoopIcon/></Box>
  );
};

export default ViewPoliceRecord;
